module.exports = __webpack_public_path__ + "static/media/contact-bg.46362da5.jpg";